// extracted by mini-css-extract-plugin
export var content = "imageGallery-module--content--eTwxm";
export var imageGalleryIcon = "imageGallery-module--image-gallery-icon--7jAQp";
export var leftNav = "imageGallery-module--leftNav--89xbV";
export var rightNav = "imageGallery-module--rightNav--Lxigg";